import styled from 'styled-components';

export const TextOverflowWrapper = styled.div`
	min-width: 3rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
